"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
exports.default = (function (href, text, key) {
    return ((0, preact_1.h)("a", { href: href, key: key, target: '_blank', rel: 'noopener noreferrer' }, text));
});
//# sourceMappingURL=default-component-renderer.js.map